import React from 'react'

type Props = { fallback?: React.ReactNode; children: React.ReactNode }
type State = { hasError: boolean }

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: unknown, info: unknown) {
    console.error('Error boundary', error, info)
    // aquí puedes loguear a Sentry, etc.
  }

  reset = () => this.setState({ hasError: false })

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="error-fallback">
            <p>Ups, algo salió mal.</p>
            <button onClick={this.reset}>Reintentar</button>
          </div>
        )
      )
    }
    return this.props.children
  }
}
